import React from 'react';
import printJS from 'print-js';
import Modal from '../modal/modal';
import Btn from '../buttons/btn';
import utils from '../../utils/product/product-utils';
import './articlesModal.css';

const ArticlesModal = (props) => {
  const hiddenFields = ['Comprobante_Id'];

  const getTitleFromKey = (key) => {
    switch (key) {
      case ' PrecioUnitario':
        return 'PRECIO LISTA';
      case ' Descuento\r':
        return 'PRECIO DESCUENTO';
      default:
        return key.toUpperCase();
    }
  };

  const getHeaders = () => {
    const keyList = Object.keys(props.articles[0]);
    keyList.push('Descuento');

    const headers = keyList.map((key, index) => {
      if (hiddenFields.includes(key)) return null;
      const title = getTitleFromKey(key);
      return <th key={index}>{title}</th>;
    });
    return headers;
  };

  const getJSONDataToPrint = () => {
    const jsonData = props.articles.map((article) => {
      const newArticle = { ...article };
      delete newArticle['Comprobante_Id'];
      newArticle[' Descuento\r'] = `${Number(article[' Descuento\r']).toFixed(2)}%`;
      newArticle[' PrecioUnitario'] = utils.formatCurrency(article[' PrecioUnitario'])
      const precioDescuento = article[' PrecioUnitario'] * (1 - article[' Descuento\r'] / 100);
      newArticle['PrecioDescuento'] = utils.formatCurrency(precioDescuento);
      newArticle['SubTotal'] = utils.formatCurrency(precioDescuento * article[' Cantidad']);
      return newArticle;
    });
    return jsonData;
  };


  const printModal = () => {
    printJS({
      printable: getJSONDataToPrint(),
      type: 'json',
      properties: [
        { field:' Cantidad', displayName: 'Cantidad' },
        { field:' Articulo_Desc', displayName: 'Articulo' },
        { field:' PrecioUnitario', displayName: 'Precio Unitario' },
        { field:' Descuento\r', displayName: 'Descuento' },
        { field:'PrecioDescuento', displayName: 'Precio con Descuento' },
        { field:'SubTotal', displayName: 'Sub Total' }
      ],
      header: `<h3 class="custom-h3">${invoice} - TOTAL: ${utils.formatCurrency(props.currentTotal)}</h3>`,
      style: '.custom-h3 { color: black; }'
    });
  };

  const getDetails = () => {
    return props.articles.map((article, index) => {

      return (
        <tr key={index}>
          {Object.values(article).map((value, i) => {
            if (i === 0) return null;
            // Price
            if (i === 4) {
              return (
                <td className="text-right" key={i}>
                  {utils.formatCurrency(value)}
                </td>
              );
            }
            // Discount price
            if (i === 5) {
              const rows = [];
              rows.push(
                <td className="text-right" key={i}>
                  {utils.formatCurrency( (1 - (value/100)) * Object.values(article)[i-1])}
                </td>
              );
              rows.push(
                <td className="text-right" key={i+1}>
                  {Number(value).toFixed(2)}%
                </td>
              );
              return rows;
            }

            return <td key={i}>{value}</td>;
          })}
        </tr>
      );
    });
  };

  const invoice = props.articles[0]['Comprobante_Id'];

  return (
    <Modal
      show={props.show}
      setShow={props.setShow}
      title={`Detalle Comprobante - ${invoice}`}
      closeButton={true}
      id="articles-modal"
    >
      <>
        <table
          id="articles-table"
          className="table table-sm table-responsive table-hover table-bordered table-custom"
        >
          <thead className="thead-light">
            <tr>{getHeaders()}</tr>
          </thead>
          <tbody>{props.articles.length && getDetails()}</tbody>
        </table>
        <div
          className="total-articles text-right">
          <h4>Total: {utils.formatCurrency(props.currentTotal)}</h4>
        </div>
        <div id="btn-print">
          <Btn
            type="button"
            name="Imprimir"
            cssClass=" btn-close btn btn-dark m2"
            fn1={() => printModal()}
          />
        </div>
      </>
    </Modal>
  );
};

export default ArticlesModal;
